import { render, staticRenderFns } from "./ColorBlocks.vue?vue&type=template&id=786d7c45&scoped=true&"
import script from "./ColorBlocks.vue?vue&type=script&lang=js&"
export * from "./ColorBlocks.vue?vue&type=script&lang=js&"
import style0 from "./ColorBlocks.vue?vue&type=style&index=0&id=786d7c45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786d7c45",
  null
  
)

export default component.exports